import Appbar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Grid from "@material-ui/core/Grid";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import styled from 'styled-components';

const ToolBarContainer = styled.div`
  display:flex;
  align-items:center;
  justify-content:space-between;
  width:100%;
`

const ToolBarItem = styled.div `


`


const getRuntimeValue = (key, fallback) => {
    const config = window.runtimeConfig || {};
    return config[key] || fallback;
};


const styles = {
    unselectedLabel : {
        color: 'rgb(255,255,255,.6)',

    },
    selectedLabel: {
  
        color: 'white',
  
      },
      appbar: {
          backgroundColor:'#304A58'
  
      },
  };

class AppHeader extends React.Component {

    handleClick = event => {
        this.setState({ anchorEl: event.currentTarget });
      };
    
      handleClose = () => {
        this.setState({ anchorEl: null });
      };
      // KeyLinks menu handlers
    handleKeyLinksClick = event => {
        this.setState({ keyLinksAnchorEl: event.currentTarget });
    };
    
    handleKeyLinksClose = () => {
        this.setState({ keyLinksAnchorEl: null });
    };
      state = {
        anchorEl: null,
        keyLinksAnchorEl: null,
      };



    buttonPropsForPath = (to,to2,classes) => this.props.path === to || this.props.path === to2 ? 
        {className:this.props.classes.selectedButton,component:Link,to,classes:{text:this.props.classes.selectedLabel}}
        : {component:Link,to,classes:{text:this.props.classes.unselectedLabel}};

    render() {

        const { aboutCurrentUser,showImpersonateModal } = this.props;
        const { anchorEl,keyLinksAnchorEl } = this.state;
        

        return (
            <div>
                
                <Appbar classes={{root:this.props.classes.appbar}} position="static">
                    <Toolbar>
                            <ToolBarContainer>
                            <ToolBarItem>
                                <Typography variant="h6">
                                    ComplianceWorks
                                </Typography>
                            </ToolBarItem>

                        <ToolBarItem>
                        {aboutCurrentUser &&
                        <Grid container spacing={0} justifyContent="center" alignItems="center">
                            <Grid item>
                                <Button {...this.buttonPropsForPath("/actions","/")} >
                                    My Actions
                                </Button>
                   
                                {(aboutCurrentUser.isAdmin || aboutCurrentUser.isOM || aboutCurrentUser.isGbuAdmin) &&
                                    <Button {...this.buttonPropsForPath("/functions")} >                                    
                                        Function Setup                                    
                                    </Button>
                                }
                                {(aboutCurrentUser.hasProjectPageAccess) &&
                                    <Button {...this.buttonPropsForPath("/projects")} >                                    
                                        Project Setup                                   
                                    </Button> 
                                }    
                                {(aboutCurrentUser.isAdmin) &&
                                    <Button {...this.buttonPropsForPath("/users")} >                                    
                                        Users                                    
                                    </Button>
                                } 
                                {/* KeyLinks Dropdown Menu */}
                                        <Button 
                                            aria-owns={keyLinksAnchorEl ? 'keylinks-menu' : undefined}
                                            aria-haspopup="true"
                                            classes={{text: this.props.classes.unselectedLabel}}
                                            onClick={this.handleKeyLinksClick}
                                        >
                                            Key Links
                                        </Button>
                                        <Menu
                                            id="keylinks-menu"
                                            anchorEl={keyLinksAnchorEl}
                                            open={Boolean(keyLinksAnchorEl)}
                                            onClose={this.handleKeyLinksClose}
                                            anchorOrigin={{
                                                vertical: 'bottom',
                                                horizontal: 'left',
                                            }}
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'left',
                                            }}
                                            getContentAnchorEl={null} 
                                        >
                                            <MenuItem onClick={() => {
                                                this.handleKeyLinksClose();
                                                const userManualUrl = getRuntimeValue('USER_MANUAL', process.env.REACT_APP_USER_MANUAL);
                                                window.open(userManualUrl, '_blank');
                                            }}>
                                                User Manual
                                            </MenuItem>
                                            <MenuItem onClick={() => {
                                                this.handleKeyLinksClose();
                                                const PBIUrl = getRuntimeValue('PBI_URL', process.env.REACT_APP_PBI_URL);
                                                window.open(PBIUrl, '_blank');
                                            }}>
                                                PowerBI
                                            </MenuItem>
                                            
                                            <MenuItem onClick={() => {
                                                this.handleKeyLinksClose();
                                                if (window.confirm('Are you sure you want to reset the cache? This will clear all cached data and Redux state.')) {
                                                    // Clear browser storage
                                                    localStorage.clear();
                                                    sessionStorage.clear();
                                                    if ('serviceWorker' in navigator && 'caches' in window) {
                                                        caches.keys().then(function(cacheNames) {
                                                            return Promise.all(
                                                                cacheNames.map(function(cacheName) {
                                                                    return caches.delete(cacheName);
                                                                })
                                                            );
                                                        });
                                                    }
                                                    document.cookie.split(";").forEach(function(c) { 
                                                        document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); 
                                                    });
                                                    
                                                    // Clear Redux state
                                                    if (this.props.resetAllReduxState) {
                                                        this.props.resetAllReduxState();
                                                    }
                                                    
                                                    console.log('Cache and Redux state cleared successfully!');
                                                    
                                                    // Redirect to actions page
                                                    this.props.history.push('/');
                                                }
                                            }}>
                                                Reset Cache
                                            </MenuItem>
                                        </Menu>                          
                            </Grid>
                        </Grid>
                        }
                        </ToolBarItem>
                        {/* Login/Logout/Profile Menu */}
                        <ToolBarItem>
                            
                                {aboutCurrentUser &&
                                <>
                                    <Button 
                                    aria-owns={anchorEl ? 'simple-menu' : undefined}
                                    aria-haspopup="true"
                                        color="inherit" 
                                        onClick={this.handleClick}

                                    >{aboutCurrentUser.displayName}</Button>
                                    {aboutCurrentUser.canImpersonate &&
                                    <Menu
                                    id="simple-menu"
                                    anchorEl={anchorEl}
                                    open={Boolean(anchorEl)}
                                    onClose={this.handleClose}
                                  >
                                  
                                    {aboutCurrentUser.canImpersonate === true && <MenuItem onClick={() => {this.setState({ anchorEl: null });showImpersonateModal(true)}} onCancel={() => showImpersonateModal(false)}>Impersonate</MenuItem>}
                                    
                                  </Menu>
                                }
                                  </>
                                }
                      
                        </ToolBarItem>
                        </ToolBarContainer>
                    </Toolbar>
                </Appbar>

            </div>
        );
    }
}

export default withRouter(withStyles(styles)(AppHeader));

